export default (pathname: string): boolean => {
  if (!pathname) return true;
  const pathparts = pathname.substring(1).split('/');
  const noFooterPages = ['checkout', 'thankyou', 'processing', 'venues', 'review', ''];
  const isProductPage = pathparts[0] === 'service' && pathparts[6] === 'product';
  const isTabPages = pathparts[1] === 'create-tab' || pathparts[1] === 'add-payment-source';
  return noFooterPages.indexOf(pathparts[0]) === -1 && !isProductPage && !isTabPages;
};
